import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_GROUP_LIST, MANAGE_GROUP_ADD, MANAGE_GROUP_DELETE, MANAGE_GROUP_VIEW, MANAGE_GROUP_UPDATE, MANAGE_GROUP_REMOVE_MEMBER } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const groupApi = createApi({
    reducerPath: 'groupApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/group",
    }),
    tagTypes: ["GroupList", "GroupDetails"],
    endpoints: (builder) => ({

        // group list
        getGroupList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, group_type = "", sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_GROUP_LIST,
                    data: { search, page, limit, sort, group_type, status }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["GroupList"]
        }),

        // Delete group
        deleteGroup: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_GROUP_DELETE}/${id}`
            }),
            invalidatesTags: ["GroupList", "GroupDetails"]
        }),

        // add group
        addGroup: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_GROUP_ADD,
                data
            }),
            invalidatesTags: ["GroupList"]
        }),

        // get group details
        getGroupDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_GROUP_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["GroupDetails"]
        }),

        // add group
        updateGroup: builder.mutation({
            query: ({ data, id }) => ({
                method: "PUT",
                url: `${MANAGE_GROUP_UPDATE}/${id}`,
                data
            }),
            invalidatesTags: ["GroupDetails", "GroupList"]
        }),

        // remove group member
        removeGroupMember: builder.mutation({
            query: ({ groupId, memberId }) => ({
                method: "DELETE",
                url: `${MANAGE_GROUP_REMOVE_MEMBER}/${groupId}/${memberId}`
            }),
            invalidatesTags: ["GroupDetails"]
        }),
    }),
})

export const {
    useGetGroupListQuery,
    useDeleteGroupMutation,
    useAddGroupMutation,
    useGetGroupDetailsQuery,
    useUpdateGroupMutation,
    useRemoveGroupMemberMutation

} = groupApi;